import React, { useCallback } from 'react';

import isEmpty from 'lodash/isEmpty';

import { Typography, normalizeSelectValue, Section } from '@gogame/components';
import { withFormField, omitFormProps, FormErrorMessage } from '@gogame/form';

import TileList from 'scenes/Gallery/components/Tiles/TileList';

import ThumbnailTile from './ThumbnailTile';

const EMPTY_OPTIONS = [];

const FamilyThumbnails = ({
  data,
  required,
  name,
  value,
  label,
  error,
  onChange,
}) => {
  const handleSelect = useCallback(
    ({ id }) => {
      onChange({}, id);
    },
    [onChange]
  );

  const isSelected = useCallback(({ id }) => id === value, [value]);

  return (
    <Section title={label} required={required}>
      {error ? (
        <FormErrorMessage variant={'caption'} name={name} />
      ) : isEmpty(data) ? (
        <Typography variant={'caption'} color={'textSecondary'}>
          No concepts selected
        </Typography>
      ) : (
        <TileList
          tileComponent={ThumbnailTile}
          rows={data}
          autoHeight={false}
          xs={4}
          tileProps={{
            isSelected: isSelected,
            onSelect: handleSelect,
          }}
          dense={true}
          disableGutters={true}
        />
      )}
    </Section>
  );
};

const normalizeValue = (value, options) => {
  if (value) {
    let normalizedValue = normalizeSelectValue(value, options);
    if (!normalizedValue && options.length) {
      return options[0].id;
    } else {
      return normalizedValue;
    }
  } else {
    if (options.length) {
      return options[0].id;
    }
  }
};

const FamilyThumbnailFormField = withFormField({
  normalizeValue,
  padding: 0,
})(({ area, form, hierarchy, onChange, value, label, ...props }) => {
  return (
    <FamilyThumbnails
      {...omitFormProps(props)}
      onChange={onChange}
      label={label}
      value={value}
      data={area.data || EMPTY_OPTIONS}
      loading={area.loading}
    />
  );
});

export default FamilyThumbnailFormField;
